import script from "./FeaturedBanner.vue?vue&type=script&lang=ts&setup=true"
export * from "./FeaturedBanner.vue?vue&type=script&lang=ts&setup=true"

import "./FeaturedBanner.vue?vue&type=style&index=0&id=dcce76fc&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dcce76fc"]])

export default __exports__